import dynamic from 'next/dynamic';
import { EChipType, TChipsData } from './types';

const ActionChip = dynamic(() => import('./variants/ActionChip'));
const Chips = dynamic(() => import('./variants/Chips'));

const DataChips = (props: TChipsData) => {
  switch (props.variant) {
    case EChipType.Action:
      return <ActionChip {...props}>{props.children}</ActionChip>;
    case EChipType.Chip:
      return <Chips {...props}>{props.children}</Chips>;

    default:
      return <></>;
  }
};

export default DataChips;
